import angular from 'angular';
import uiRouter from 'angular-ui-router';
import termsComponent from './terms.component';

let termsModule = angular.module('terms', [
  uiRouter
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $stateProvider
    .state('guest.terms', {
      url: '/terms',
      template: '<terms class="terms"></terms>'
    });
})

.component('terms', termsComponent);

export default termsModule;



// WEBPACK FOOTER //
// ./src/app/screens/guest/screens/terms/index.js